import React from 'react';

import {Picture} from '@udemy/react-core-components';

import styles from './messaging-banner.module.less';

import type {MessagingBannerVisual} from './messaging-banner.react-component';

const BENTO_BANNER_IMAGE_URL = `${process.env.ASSET_PREFIX}/staticx/udemy/images/marketplace/messaging-module/bento_banner_graphic-v1.jpg`;

export const BENTO_VISUAL_CONFIG: Record<string, MessagingBannerVisual> = {
    lihp_marketing_messaging_pp_upsell: {
        backgroundStyle: {
            backgroundImage:
                'radial-gradient(100% 100% at 0% 0%, #5022C3 30%, #6D28D2 50%, #892DE1 80%)',
        },
        // Bento-specific banner graphic, built to the Figma spec.
        endImageArea: (
            <Picture
                src={BENTO_BANNER_IMAGE_URL}
                sources={[]}
                alt=""
                width="unset"
                height="unset"
                className={styles['image-fill']}
                imgClassName={styles.image}
            />
        ),
    },
    lihp_marketing_messaging_nav_ai: {
        size: 'small',
        backgroundStyle: {
            backgroundImage:
                'radial-gradient(100% 100% at 0% 0%, #006840 30%, #008E4F 49.5%, #00A459 80%)',
        },
    },
    lihp_marketing_messaging_nav_certifications: {
        size: 'small',
        backgroundStyle: {
            backgroundImage:
                'radial-gradient(103.23% 103.23% at 0% 0%, #009FA7 30%, #00B6BC 50%, #3CD2D7 80%)',
        },
    },
};
